import { useTranslation } from 'react-i18next';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import { Button, Icons } from 'ui-kit';
import cn from 'clsx';

import { i18n, LANGUAGES, Lang } from 'utils/i18n';

import 'antd/lib/menu/style/css';
import 'antd/lib/dropdown/style/css';

import styles from './SelectLanguage.module.scss';

interface Props {
  className?: string;
}

const langs = ((i18n.options.supportedLngs as string[]) || []).filter(
  (l) => l !== 'cimode'
);

const menu = (
  <Menu>
    {langs.map((lng) => (
      <Menu.Item key={lng} onClick={() => i18n.changeLanguage(lng)}>
        {LANGUAGES[lng as Lang].label}
      </Menu.Item>
    ))}
  </Menu>
);

export function SelectLanguage({ className }: Props) {
  const {
    i18n: { language: lng }
  } = useTranslation();

  if (langs.length < 2) return null;

  return (
    <Dropdown overlay={menu} trigger={['click', 'hover']}>
      <Button variant="link" className={cn(className, styles.selectLanguage)}>
        {LANGUAGES[lng as Lang].label.slice(0, 3)}
        <Icons.ArrowDrop />
      </Button>
    </Dropdown>
  );
}
